let AWS = {
    "REGION": "us-east-1",
    "USER_POOL_ID": "us-east-1_uFnNavbn3",
    "USER_POOL_APP_CLIENT_ID": "5avj457rvhloh6ue6f2m21labl"
}

export default AWS;
